<div class="container mb-3 rec">
  <div class="header" [ngClass]="{'sp': !isNews}">
    <div class="d-flex">
      <div class="d-flex align-items-center">
        <div class="logo-icon"></div>
        <h3 class="d-inline">
          <a [routerLink]="['/', isNews ? 'news' : 'svideo']">{{ title }}</a>
        </h3>
        <a [routerLink]="['/', isNews ? 'news' : 'svideo']" class="mainColor d-flex align-items-center ml-4">
          <span>更多</span>
          <span class="iconfont iconjiantou_liebiaoxiangyou fs-16"></span>
        </a>
      </div>
      <!-- <div class="refresh text-small">
      </div> -->
    </div>
  </div>
  <div *ngIf="showOutDated" class="d-flex hot-place" [ngClass]="{'no-bg':recommendedNewsList.length > 0}">
    <!-- <app-dn-headline-slider [items]="sliderItems">
    </app-dn-headline-slider> -->
    <div *ngIf="recommendedNewsList.length > 0" class="keepOneLine">
      <div class="news-row-1">
        <div class="rec-news-item d-inline-block" *ngFor="let news of firstPart; let last = last">
          <a routerLink="{{ news.path }}" [title]="news.title" [queryParams]="news.params">
            <div class="img-containner">
              <img class="hover-scale" src="{{ news.image}}?w=216&h=120&format=jpg&mode=crop" alt="{{news.title}}"/>
            </div>

            <div class="title-wrap">
              {{ news.title }}
              <span class="play-times fs-12 sub-text-color mt-1">{{ news.views | chineseCounter }}次播放</span>
            </div>
          </a>

        </div>
      </div>
      <div>
        <div class="rec-news-item d-inline-block" *ngFor="let news of secondPart; let last = last">
          <a routerLink="{{ news.path }}" [title]="news.title" [queryParams]="news.params">
            <div class="img-containner">
              <img class="hover-scale" src="{{ news.image  }}?w=216&h=120&format=jpg&mode=crop" alt="{{news.title}}"/>
            </div>
            <div class="title-wrap">
              {{ news.title }}
              <span class="play-times fs-12 sub-text-color mt-1">{{ news.views | chineseCounter }}次播放</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="rec-slider position-relative d-flex hot-place" [ngClass]="{'no-bg':newsList.length > 0}">
    <div class="nav-shadow-cover last" *ngIf="currentIndex > 0"
      [ngClass]="{'hidden': hideLeft}">
    </div>
    <div class="nav-btn last" *ngIf="currentIndex > 0"
      [ngClass]="{'hidden': hideLeft}">
      <i class="iconfont iconjiantou_liebiaoxiangzuo" (click)="navLast()"></i>
    </div>
    <div class="rec-track d-flex" #track>
      <div class="new-svideo-container" [display]="7"
        *ngFor="let item of newsList;" [video]="item"
        (currentMediaKey)="currentMediaKeyHandler($event)" (playerShowed)="previewHandler($event)">
      </div>
    </div>
    <div class="nav-shadow-cover next" *ngIf="currentIndex < (newsList.length - newColumn)"
      [ngClass]="{'hidden': hideRight}">
    </div>
    <div class="nav-btn next" *ngIf="currentIndex < (newsList.length - newColumn)" 
      [ngClass]="{'hidden': hideRight}">
      <i class="iconfont iconjiantou_liebiaoxiangyou" (click)="navNext()"></i>
    </div>
  </div>
</div>